// Fetch all watcher modules
const modules = import.meta.glob('./**/*.ts', { import: 'default', eager: true } as Record<string, string | boolean>);
export default function () {
  Object.values(modules).forEach((module) => {
    module();
  });
}
